import * as React from 'react';
import classnames from 'classnames';
import { H2 } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import '@swc/helpers';
import '@grandvisionhq/forms';
import '@grandvisionhq/analytics';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import '../../../../../types/product.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/elements';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/common';
import '../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import '@grandvisionhq/icons';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '../../../../../hooks/use-product-view-history.js';
import '../../../../../slots/context.js';
import '@grandvisionhq/content';
import '../../types/quantity-discounts.js';
import { useCLEcommContext } from '../../context/CLEcommContext.js';

const LensesPerBox = ({ className , hideTitle =false  })=>{
    const { getLabel  } = useIntl();
    const { state  } = useCLEcommContext();
    const { lensesPerBox  } = state.configurations;
    const labels = {
        title: getLabel('products.contactLenses.boxQuantity'),
        perBox: getLabel('products.perBox'),
        unit: lensesPerBox === 1 ? getLabel('products.unit.contactLens') : getLabel('products.unit.contactLenses')
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('lenses-per-box', className),
        "data-t": "product-detail-unit-info"
    }, !hideTitle && /*#__PURE__*/ React.createElement(H2, {
        className: "lenses-per-box__title",
        variant: "heading-smallest"
    }, labels.title), `${lensesPerBox} ${labels.unit} ${labels.perBox}`);
};

export { LensesPerBox };
//# sourceMappingURL=LensesPerBox.js.map
